import type { User } from 'firebase/auth';

import type { SalaTeacherProfile } from './types';

/** Nombre visible del docente logueado (perfil Sala → Auth Firebase). */
export function resolveSalaTeacherDisplayName(
  profile: Pick<SalaTeacherProfile, 'displayName'> | null | undefined,
  user?: Pick<User, 'displayName'> | null,
): string {
  const fromProfile = String(profile?.displayName || '').trim();
  if (fromProfile) return fromProfile;
  return String(user?.displayName || '').trim();
}
